"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLink1 = exports.link1UseableDef = void 0;
const echain_shared_modelling_1 = require("@igus/echain-shared-modelling");
const ArticleBase_1 = require("../../ArticleBase");
const echain_product_models_1 = require("@igus/echain-product-models");
exports.link1UseableDef = {
    parent: ArticleBase_1.articleBaseUseableDef,
    validation: {
        ArticleType: (v) => v === echain_product_models_1.ArticleType.link,
    },
};
exports.isLink1 = echain_shared_modelling_1.UseableUtil.createGuard(exports.link1UseableDef);
//# sourceMappingURL=Link1.js.map